import React from 'react';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { COLOR_BY_NUMBER } from '../../../enums/colorByNumber';

function ResultRow({ result, setSelectedResultInfo, t, roundId }) {
  return (
    <div key={result.hash || result.salt} className='results-fairness-check-row'>
      <div className='results-fairness-check-column'>
        <span className='results-fairness-check-id'>{result.roundId}</span>
      </div>
      <div className='results-fairness-check-column'>
        {roundId === result.roundId ? (
          <div className='res-loading-block'>
            <div className='res-loading-block-circle' />
            <div className='res-loading-block-circle' />
            <div className='res-loading-block-circle' />
          </div>
        ) : result.roundData ? (
          <div className={`res-row-bg type-${COLOR_BY_NUMBER[result.roundData.number].type}`}>
            <p className='res-row-bg-number'>{result.roundData.number}</p>
          </div>
        ) : (
          <p className='res-row-text-upcoming'>{t('UPCOMING')}</p>
        )}
      </div>
      <div
        className='results-fairness-check-column check'
        onClick={() => {
          setSelectedResultInfo({
            ...result,
            resultKey: result.resultKey || '',
            resultHash: result.resultHash || '',
            resultSalt: result.resultSalt || '',
          });
          popupStore.open({ name: PopUps.CheckHash });
        }}
      >
        <i className='icon-security results-fairness-check-icon' />
      </div>
    </div>
  );
}

export default ResultRow;
